export default {
  api: {
    protocol: process.env.VUE_APP_API_PROTOCOL,
    hostname: process.env.VUE_APP_API_HOSTNAME,
    url: `${process.env.VUE_APP_API_PROTOCOL}://${process.env.VUE_APP_API_HOSTNAME}:${process.env.VUE_APP_API_PORT}/api`,
    privateEndpointsPrefix: process.env.VUE_APP_PRIVATE_ENDPOINTS_PREFIX,
    endpoints: {
      authentication: process.env.VUE_APP_ENDPOINT_AUTHENTICATION,
      analysisRequest: process.env.VUE_APP_ENDPOINT_ANALYSIS_REQUEST,
      nomenclature: process.env.VUE_APP_ENDPOINT_NOMENCLATURE,
      samples: process.env.VUE_APP_ENDPOINT_SAMPLES,
      sampleBatch: process.env.VUE_APP_ENDPOINT_SAMPLE_BATCH,
      resultFile: process.env.VUE_APP_ENDPOINT_RESULT_FILE,
      users: process.env.VUE_APP_ENDPOINT_USERS
    }
  },
  security: {
    jwtRefreshCookie: process.env.VUE_APP_JWT_REFRESH_COOKIE || 'refresh_token',
    jwtRefreshThreshold: process.env.VUE_APP_JWT_REFRESH_THRESHOLD || 60,
    ssoUrl: process.env.VUE_APP_JWT_SSO_URL,
    clientId: process.env.VUE_APP_JWT_SSO_CLIENT_ID,
    redirectUrl: process.env.VUE_APP_JWT_SSO_REDIRECT_URL,
    miscParams: process.env.VUE_APP_JWT_SSO_MISC_PARAMS
  },
  timeoutMs: process.env.VUP_APP_TIMEOUT_MS || 20000
} as AppConfig;

export interface AppConfig {
  api: {
    protocol: string;
    hostname: string;
    url: string;
    privateEndpointsPrefix: string;
    endpoints: {
      authentication: string;
      analysisRequest: string;
      nomenclature: string;
      samples: string;
      sampleBatch: string;
      resultFile: string;
      users: string;
    };
  };
  security: {
    jwtRefreshCookie: string;
    jwtRefreshThreshold: number;
    ssoUrl: string;
    clientId: string;
    redirectUrl: string;
    miscParams: string;
  };
  timeoutMs: number;
}
